<template>
    <div class="loading_top_wrap">
        <div class="pop_overlay_black">
            <div v-if="loading" class="loading_bg round_none transparent" style="z-index: 508">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_wrap rsv2_manager_set_pop" style="width: 580px">
                <div class="pop_title">
                    <span class="title">{{ $t('popup_export_to_excel.title') }}</span>
                    <button class="mgl_auto" @click="action_ClosePopup">
                        <v-icon large>mdi-close</v-icon>
                    </button>
                </div>

                <div class="pop_desc lgray black_txt" style="border-bottom: 1px solid var(--gray60)">{{ $t('popup_export_to_excel.sub_title') }}</div>

                <div class="pop_cont">
                    <ul class="form_list">
                        <li class="title" style="color: var(--gary100)">{{ $t('popup_export_to_excel.label_select_group') }}</li>
                        <li class="cont">
                            <div class="custom_select">
                                <div class="input_s w_full" @click.stop="actions_ShowGroupSelectList">
                                    <span class="txt" style="max-width: 270px">{{ selectedGroupsString }}</span>
                                    <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
                                </div>
                                <div class="list multiple" style="max-height: 155px" v-if="isShowGroupSelectList" v-clickoutside:actions_HideGroupSelectList="{}">
                                    <div v-if="!groups?.length">
                                        <div class="item">
                                            <span class="txt ellipsis gray_txt">선택 가능한 그룹이 없습니다.</span>
                                        </div>
                                    </div>
                                    <div class="item" v-if="!!groups && groups.length > 0">
                                        <label class="check_wrap">
                                            <input type="checkbox" :checked="isAllGroupsSelected" @change="toggleAllGroups" />
                                            <span class="checkmark"></span>
                                            <span class="txt ellipsis">{{ $t('popup_export_to_excel.label_all_group') }}</span>
                                        </label>
                                    </div>
                                    <div class="item" v-for="group in groups" :key="group._id">
                                        <label class="check_wrap">
                                            <input type="checkbox" :checked="selectedGroups.includes(group._id)" @change="toggleGroupSelection(group)" />
                                            <span class="checkmark"></span>
                                            <span class="txt ellipsis">{{ group.title }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <small class="red_txt" v-if="!!selectedGroups && !selectedGroups.length">그룹은 최소 1개 이상 선택해 주세요.</small>
                        </li>
                    </ul>

                    <ul class="form_list">
                        <li class="title" style="color: var(--gary100)">{{ $t('popup_export_to_excel.label_select_staff') }}</li>
                        <li class="cont">
                            <div class="custom_select">
                                <div class="input_s w_full" @click.stop="actions_ShowManagerSelectList">
                                    <span class="txt" style="max-width: 270px;">{{ selectedManagersString }}</span>
                                    <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
                                </div>
                                <div class="list multiple" style="max-height: 155px" v-if="isShowManagerSelectList" v-clickoutside:actions_HideManagerSelectList="{}">
                                    <div v-if="!managers?.length">
                                        <div class="item">
                                            <span class="txt ellipsis gray_txt">선택 가능한 담당자가 없습니다.</span>
                                        </div>
                                    </div>
                                    <div class="item" v-if="!!managers && managers.length > 0">
                                        <label class="check_wrap">
                                            <input type="checkbox" :checked="isAllManagersSelected" @change="toggleAllManagers" />
                                            <span class="checkmark"></span>
                                            <span class="txt ellipsis">{{ $t('reservationwindow.header.label_staff_column_all') }}</span>
                                        </label>
                                    </div>
                                    <div class="item" v-for="manager in managers" :key="manager._id">
                                        <label class="check_wrap" v-if="manager._id !== undefined">
                                            <input type="checkbox" :checked="selectedManagers.includes(manager._id)" @change="toggleManagerSelection(manager)" />
                                            <span class="checkmark"></span>
                                            <span class="txt ellipsis">{{ manager.title }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <small class="red_txt" v-if="!!selectedManagers && !selectedManagers.length">담당자를 최소 1개 이상 선택해 주세요.</small>
                        </li>
                    </ul>

                    <ul class="form_list">
                        <li class="title" style="color: var(--gary100)">{{ $t('popup_export_to_excel.label_time_interval') }}</li>
                        <li class="cont">
                            <select class="input_s w_full" :value="selectedTimeInterval" @change="selectedTimeInterval = Number($event.target.value)">
                                >
                                <option :value="5">{{ $t('reservationwindow.header.label_5_min_interval') }}</option>
                                <option :value="10">{{ $t('reservationwindow.header.label_10_min_interval') }}</option>
                                <option :value="15">{{ $t('reservationwindow.header.label_15_min_interval') }}</option>
                                <option :value="20">{{ $t('reservationwindow.header.label_20_min_interval') }}</option>
                                <option :value="30">{{ $t('reservationwindow.header.label_30_min_interval') }}</option>
                                <option :value="60">{{ $t('reservationwindow.header.label_60_min_interval') }}</option>
                            </select>
                        </li>
                    </ul>
                </div>
                <div class="btn_wrap">
                    <button class="btn btn_l btn_gray" @click="action_ClosePopup">{{ $t('common.cancel') }}</button>
                    <button class="btn btn_l btn_blue" @click="action_SaveExcel" :disabled="isSaveButtonDisabled">{{ $t('common.save') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import ReservationPositionCalculator from '../../../ReservationPositionCalculator'
import { sheetState } from '../../../sheet-state'
import { closePopup, sheetOverlays } from '../../../sheet-overlays'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters } from '../../../sheet-filters'
import { sheetRefresh } from '../../../sheet-refresh'
import scheduleExcelController from './ScheduleExcelController.js'
import moment from '@/util/MPMoment'
import axios from 'axios'
import { useQueryClient } from '@tanstack/vue-query'
import { v2WorkRecordFindDateQueryOptions } from '@/composables/queries/v2workrecord/use-v2-workrecord-find-date-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2ReservationCellKeys, v2ReservationCellFindQueryOptions } from '@/composables/queries/v2reservationcell/use-v2-reservationcell-find-query'
import { v2ReservationBlockKeys, v2ReservationBlockFindQueryOptions } from '@/composables/queries/v2reservationblock/use-v2-reservationblock-find-query'
import { v2ReservationListQueryOptions } from '@/composables/queries/v2reservation/use-v2-reservation-list-query'

const groupReservationsByColumnID = (cellArr) => {
    const grouped = new Map()

    for (const { columnID, reservations } of cellArr) {
        if (!grouped.has(columnID)) {
            grouped.set(columnID, [])
        }
        grouped.get(columnID).push(...reservations)
    }

    return Array.from(grouped.entries()).map(([columnID, reservations]) => ({
        columnID,
        reservations
    }))
}

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    data() {
        return {
            sheetState,
            sheetOverlays,
            sheetAxis,
            sheetFilters,
            sheetRefresh,
            isShowGroupSelectList: false,
            isShowManagerSelectList: false,
            selectedGroups: [],
            selectedManagers: [],
            selectedTimeInterval: 15,
            reservations: [],
            loading: false,
            reservationBlocksAndColors: [],
            workCodes: [],
            workCodeArr: [],
            targetDateString: '',
            originalWorkRecords: [],
            lastFetchDate: undefined,
            blocksAndColors: []
        }
    },
    mounted() {
        this.selectedGroups = this.groups?.map((group) => group._id)
        this.selectedManagers = this.groups?.flatMap((group) => group.columns).map((column) => column._id)
    },
    watch: {
        'sheetRefresh.refreshFlagMoment': {
            deep: true,
            handler: function () {
                if (this.selectedDateString !== this.targetDateString) {
                    this.reservations = []
                    this.reservationBlocksAndColors = []
                    this.workCodes = []
                }
                this.targetDateString = this.selectedDateString
                this.requestFetchWorkHoliday()
            }
        },
        timeArray: {
            deep: true,
            handler: function (newValue, oldValue) {
                if (!newValue) {
                    return
                }
                const n = moment(newValue?.[0]?.time).format('YYYY-MM-DD')
                const o = moment(oldValue?.[0]?.time).format('YYYY-MM-DD')
                if (n === o) {
                    if (newValue.length !== oldValue.length) {
                        this.computedEachCellBlocksAndColors()
                        this.computedEachCellWorkCode()
                    }
                }
            }
        },
        selectedGroups: {
            handler() {
                if (!this.groups || !this.selectedGroups) return

                this.selectedManagers = this.groups
                    .filter((group) => this.selectedGroups.includes(group._id))
                    .flatMap((group) => group.columns)
                    .map((column) => column._id)
            },
            deep: true
        }
    },
    computed: {
        selectedGroupsString() {
            if (!this.groups || this.selectedGroups.filter(Boolean).length === 0) return '-'

            const count = this.selectedGroups.filter(Boolean).length
            if (count === this.groups.length) return this.$t('popup_export_to_excel.label_all_group')

            const name = this.groups.find((c) => c._id === this.selectedGroups[0])?.title || ''
            return count > 1 ? `${name} 외 ${count - 1}개` : name
        },

        selectedManagersString() {
            if (!this.managers || this.selectedManagers.filter(Boolean).length === 0) return '-'

            const count = this.selectedManagers.filter(Boolean).length
            if (count === this.managers.length) return this.$t('reservationwindow.header.label_staff_column_all')

            const name = this.managers.find((c) => c._id === this.selectedManagers[0])?.title || ''
            return count > 1 ? `${name} 외 ${count - 1}명` : name
        },

        isAllGroupsSelected() {
            return this.groups.length && this.groups.every((group) => this.selectedGroups.includes(group._id))
        },
        isAllManagersSelected() {
            return this.managers.length && this.managers.every((manager) => this.selectedManagers.includes(manager._id))
        },
        isSaveButtonDisabled() {
            const hasNoGroups = !this.groups || this.groups.length === 0
            const hasNoManagers = !this.managers || this.managers.length === 0
            const hasNoSelectedGroups = !!this.selectedGroups && this.selectedGroups.length === 0
            const hasNoSelectedManagers = !!this.selectedManagers && this.selectedManagers.length === 0
            const isLoading = this.loading

            return isLoading || hasNoGroups || hasNoManagers || hasNoSelectedGroups || hasNoSelectedManagers
        },
        usingChartNumber() {
            return this.servicesetting?.setting?.usingChartNumber ?? false
        },
        colorPalette() {
            return this.sheetState.reservationSetting?.statusColorPaletteID?.basicPalette ?? []
        },
        timeArray() {
            return this.sheetAxis.timeArray
        },
        managers() {
            return this.groups
                ?.filter((group) => this.selectedGroups.includes(group._id))
                .flatMap((group) => group.columns)
                .map((column) => ({
                    _id: column._id,
                    title: column.title
                }))
                ?.filter((manager) => !manager.isEmpty && manager._id)
        },
        columns() {
            return deepCopy(this.groups)
                .filter((group) => this.selectedGroups.includes(group._id))
                .map((group) => {
                    if (group.columns.length === 0)
                        return {
                            _id: undefined,
                            groupID: { _id: group._id }
                        }

                    return group.columns.map((column) => {
                        if (!this.selectedManagers.includes(column._id)) return

                        return {
                            ...column
                        }
                    })
                })
        },
        columnIds() {
            return this.columns.flatMap((column) => column).map((column) => column?._id)
        },
        employeeIdsWithColumnsId() {
            return this.columns
                .flatMap((column) => column)
                .map((column) => {
                    return {
                        columnID: column._id,
                        employeeID: column?.employeeID
                    }
                })
                .filter((v) => v.employeeID && v.columnID)
        },
        usableGroups() {
            return this.sheetFilters.usableGroups
        },
        groups() {
            return this.usableGroups.filter((g) => g._id).length ? deepCopy(this.usableGroups) : []
        },
        isShow() {
            return this.sheetOverlays.isShowExcelSavePopup
        },
        states() {
            return this.sheetFilters.states?.filter((c) => c.isSelected).map((c) => c._id)
        },
        selectedDate() {
            return this.sheetAxis.selectedDate
        },
        selectedDateString() {
            return moment(this.selectedDate).format('YYYY-MM-DD')
        },
        simpliedGroupsData() {
            return this.groups?.map(({ columns, title, _id }) => {
                return {
                    _id,
                    title,
                    columns: columns?.map(({ programs, _id, title }) => ({ programs, _id, title }))
                }
            })
        },
        simplifiedTimesData() {
            return this.timeArray?.map(({ timeString }) => timeString) ?? []
        },
        simplifiedCellsData() {
            const groupedByColumnID = this.reservations.reduce((accumulator, current) => {
                const columnID = current.columnID._id
                const {
                    _id,
                    startedAt,
                    endedAt,
                    userName,
                    hserviceID: { birth, chartNumber },
                    groupTitle,
                    columnTitle,
                    statusTitle,
                    programTitle,
                    note,
                    statusID: { paletteIndex },
                    x
                } = current

                if (!accumulator.has(columnID)) {
                    accumulator.set(columnID, {
                        columnID,
                        reservations: []
                    })
                }

                accumulator.get(columnID).reservations.push({
                    _id,
                    startedAt,
                    endedAt,
                    userName,
                    birth,
                    groupTitle,
                    columnTitle,
                    statusTitle,
                    programTitle,
                    x,
                    note,
                    columnID,
                    usingChartNumber: this.usingChartNumber,
                    chartNumber: chartNumber ?? '',
                    bgColor: this.colorPalette[paletteIndex] ?? '#FFFFFF'
                })

                return accumulator
            }, new Map())

            const resultArray = Array.from(groupedByColumnID.values())
            return groupReservationsByColumnID(resultArray)
        },
        excelData() {
            return {
                groupArr: this.simpliedGroupsData ?? [],
                timeArr: this.simplifiedTimesData ?? [],
                cellArr: this.simplifiedCellsData ?? [],
                blocksAndColorsArr: this.reservationBlocksAndColors ?? [],
                workCodesArr: this.workCodes ?? []
            }
        }
    },
    methods: {
        computedEachCellWorkCode() {
            try {
                const tempWorkCodeArr = new Set()

                for (const record of this.originalWorkRecords) {
                    const result = this.parseWorkRecordData(record)
                    for (const code of result) {
                        tempWorkCodeArr.add(code)
                    }
                }

                this.workCodeArr = Array.from(tempWorkCodeArr).filter((c) => c)

                const codes = this.workCodeArr
                    .reduce((acc, item) => {
                        if (item?.columnIDArr && Array.isArray(item.columnIDArr)) {
                            if (item.columnIDArr.length === 1) {
                                acc.push({ ...item, columnID: item.columnIDArr[0] })
                            } else {
                                for (const columnID of item.columnIDArr) {
                                    acc.push({ ...item, columnID })
                                }
                            }
                        }
                        return acc
                    }, [])
                    .filter((c) => c && c.isRemoved !== true)

                const seenColumnIDs = new Set()
                const deduplicatedCodes = codes.filter((code) => {
                    if (seenColumnIDs.has(code.columnID)) {
                        return false
                    }
                    seenColumnIDs.add(code.columnID)
                    return true
                })

                this.workCodes = deduplicatedCodes.map((code) => {
                    const workCode = deepCopy(code)

                    if (workCode.isDefault) {
                        workCode.isFirstIndex = workCode.isFirstIndex === undefined
                        return workCode
                    }

                    const targetTime = moment(workCode.startedAt).format('HH:mm')
                    const [targetHour, targetMinute] = targetTime.split(':').map(Number)
                    const targetEndHour = targetHour + Math.floor((targetMinute + this.selectedTimeInterval) / 60)
                    const targetEndMinute = (targetMinute + this.selectedTimeInterval) % 60

                    const setMomentTime = (time) => {
                        return moment(this.selectedDate)
                            .clone()
                            .set({ hour: moment(time).hour(), minute: moment(time).minute() })
                    }
                    const startedAt = setMomentTime(workCode.startedAt)
                    const endedAt = setMomentTime(workCode.endedAt)

                    const startHour = Number.parseInt(startedAt.format('HH:mm').split(':')[0])
                    const startMinute = Number.parseInt(startedAt.format('HH:mm').split(':')[1])
                    const endHour = Number.parseInt(endedAt.format('HH:mm').split(':')[0])
                    const endMinute = Number.parseInt(endedAt.format('HH:mm').split(':')[1])

                    const isOutsideWorkCode =
                        targetEndHour < startHour ||
                        (targetEndHour === startHour && targetEndMinute <= startMinute) ||
                        targetHour > endHour ||
                        (targetHour === endHour && targetMinute >= endMinute)

                    if (isOutsideWorkCode) {
                        workCode.isFirstIndex = workCode.isFirstIndex === undefined
                        return workCode
                    }
                    return workCode
                })
            } catch (error) {
                console.error('Error in computedEachCellWorkCode:', error)
                this.workCodes = []
            }
        },
        computedEachCellBlocksAndColors() {
            if (!this.originalBlocksAndColors.length) {
                return
            }

            const result = []

            for (const item of this.originalBlocksAndColors) {
                for (const column of item.columns) {
                    const existingColumn = result.find((r) => r.columnID === column)
                    if (existingColumn) {
                        existingColumn.blocksAndColors.push(item)
                    } else {
                        result.push({
                            columnID: column,
                            blocksAndColors: [item]
                        })
                    }
                }
            }

            this.reservationBlocksAndColors = result
        },
        isDateMatch(fetchParamDate) {
            const currentDate = moment(this.selectedDate).format('YYYY-MM-DD')
            return fetchParamDate === currentDate
        },
        parseTime(data) {
            const time = moment(this.selectedDate)
            let start
            let end
            if (data.isDaybreak) {
                start = time.clone().set({ hour: 0, minute: 0 })
                end = time.clone().set({ hour: 23, minute: 55 })
            } else {
                const [sh, sm] = data.startTime.split(':')
                const [eh, em] = data.endTime.split(':')
                start = time.clone().set({ hour: sh, minute: sm })
                end = time.clone().set({ hour: eh, minute: em })
            }
            return { start, end }
        },
        parseWorkRecordData(record) {
            let employeeTitle
            let workRecord
            let employeeID
            let columnIDArr

            const temp = []

            if (!record.employees?.length) return []

            for (const e of record.employees) {
                const columnIDs = this.employeeIdsWithColumnsId.filter((v) => v.employeeID === e._id).map((v) => v.columnID)

                if (columnIDs.length > 0) {
                    employeeTitle = e.title
                    workRecord = record
                    employeeID = e._id
                    columnIDArr = columnIDs
                }

                if (workRecord?.isCustomized) {
                    temp.push({
                        isCustomized: true,
                        employeeTitle: employeeTitle,
                        startedAt: workRecord.startedAt,
                        endedAt: workRecord.endedAt,
                        employeeID: employeeID,
                        columnIDArr: columnIDArr
                    })
                } else {
                    const workCode = deepCopy(workRecord?.workCodeID)
                    if (workCode) {
                        workCode.employeeTitle = employeeTitle
                        workCode.employeeID = employeeID
                        workCode.columnIDArr = columnIDArr
                        temp.push(workCode)
                    }
                }
            }
            return temp
        },
        parseBlockAndColorData(c, b) {
            const colors = c?.map((c) => ({ ...c, cellType: 'color' })) ?? []

            const blocks =
                b
                    ?.map((b) => {
                        if (!b.startTime || !b.endTime) {
                            return null
                        }
                        const { start, end } = this.parseTime(b)
                        return {
                            ...b,
                            cellType: 'block',
                            startedAt: start,
                            endedAt: end
                        }
                    })
                    .filter((b) => b != null) ?? []

            return [...blocks, ...colors]
        },
        async requestFetchReservationBlockAndColor() {
            try {
                const date = moment(this.selectedDate).format('YYYY-MM-DD')
                // 진행 중인 이전 조회 취소 — 레거시 axios cancelToken 흐름의 대체
                await Promise.all([
                    this.queryClient.cancelQueries({ queryKey: v2ReservationCellKeys.all }),
                    this.queryClient.cancelQueries({ queryKey: v2ReservationBlockKeys.all })
                ])

                const hospitalID = this.hospital.selectedHospital._id
                const params = {
                    hospitalID: hospitalID,
                    columnID: this.columnIds.filter((c) => c),
                    date: date,
                    isRemoved: false,
                    key: 'modifiedAt',
                    way: -1
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const [cells, blocks] = await Promise.all([
                    this.queryClient.fetchQuery(v2ReservationCellFindQueryOptions(params)),
                    this.queryClient.fetchQuery(v2ReservationBlockFindQueryOptions(params))
                ])

                if (!this.isDateMatch(date)) {
                    return
                }

                this.originalBlocksAndColors = deepCopy(this.parseBlockAndColorData(cells, blocks))
            } catch (err) {
                // 취소(새 요청으로 대체)는 로그하지 않는다 — 기존 axios.isCancel 미러링
                if (err?.name !== 'CancelledError' && !axios.isCancel(err)) {
                    console.log('Error Fetching reservation blocks & colors: ', err)
                }
            }
        },
        async requestFetchWorkRecords() {
            try {
                const date = moment(this.selectedDate).format('YYYY-MM-DD')
                const hospitalID = this.hospital.selectedHospital._id

                const params = {
                    hospitalID: hospitalID,
                    startDate: date,
                    endDate: date,
                    isRemoved: false
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.originalWorkRecords = await this.queryClient.fetchQuery(v2WorkRecordFindDateQueryOptions(params))
            } catch (err) {
                console.log('Error Fetching work records: ', err)
            }
        },
        async loadReservations(columns) {
            this.loading = true
            const flatColumns = columns.flatMap((column) => column)
            this.reservations = []

            for (let i = 0; i < flatColumns.length; i++) {
                if (flatColumns[i]?._id === undefined) {
                    continue
                }

                const startedAt = moment(this.selectedDate).startOf('days')
                const endedAt = moment(this.selectedDate).endOf('days')

                const hospitalID = this.hospital.selectedHospital._id
                const model = {
                    hospitalID: hospitalID,
                    groupID: flatColumns[i].groupID,
                    columnID: flatColumns[i]._id,
                    isRemoved: false,
                    statusID: this.states,

                    startedAt: startedAt.toString(),
                    endedAt: endedAt.toString()
                }
                try {
                    await this.runAlgorithm(await this.queryClient.fetchQuery(v2ReservationListQueryOptions(model)))
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 다음 컬럼 진행
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                }
            }

            this.loading = false
        },

        async runAlgorithm(reservations) {
            this.calculator = new ReservationPositionCalculator()
            this.calculator.reservations = reservations
            const sheetStartedAt = moment(this.sheetAxis.sheetStartedAt)
            this.calculator.startTime = moment(this.selectedDate).set('hours', sheetStartedAt.hours()).set('minutes', sheetStartedAt.minutes())

            try {
                const result = await this.calculator.run()
                this.reservations.push(...result)
            } catch (error) {
                console.error('reservation position calculator error:', error)
            }
        },
        toggleAllGroups() {
            if (this.isAllGroupsSelected) {
                this.selectedGroups = []
            } else {
                this.selectedGroups = this.groups?.map((group) => group._id)
            }
        },
        toggleGroupSelection(group) {
            const index = this.selectedGroups.indexOf(group._id)
            if (index === -1) {
                this.selectedGroups.push(group._id)
            } else {
                this.selectedGroups.splice(index, 1)
            }
        },
        toggleAllManagers() {
            if (this.isAllManagersSelected) {
                this.selectedManagers = []
            } else {
                this.selectedManagers = this.managers.map((manager) => manager._id)
            }
        },
        toggleManagerSelection(manager) {
            const index = this.selectedManagers.indexOf(manager._id)
            if (index === -1) {
                this.selectedManagers.push(manager._id)
            } else {
                this.selectedManagers.splice(index, 1)
            }
        },

        action_ClosePopup() {
            closePopup()
        },
        actions_ShowGroupSelectList() {
            this.isShowManagerSelectList = false
            this.isShowGroupSelectList = !this.isShowGroupSelectList
        },
        actions_HideGroupSelectList() {
            this.isShowGroupSelectList = false
        },
        actions_ShowManagerSelectList() {
            this.isShowGroupSelectList = false
            this.isShowManagerSelectList = !this.isShowManagerSelectList
        },
        actions_HideManagerSelectList() {
            this.isShowManagerSelectList = false
        },
        async fetchData() {
            const selectedDateString = moment(this.selectedDate).format('YYYY-MM-DD')
            if (selectedDateString !== this.lastFetchDate) {
                this.originalWorkRecords = []
                this.originalBlocksAndColors = []
            }
            this.lastFetchDate = selectedDateString
            await Promise.all([this.loadReservations(this.columns), this.requestFetchWorkRecords(), this.requestFetchReservationBlockAndColor()])

            this.computedEachCellWorkCode()
            this.computedEachCellBlocksAndColors()
        },
        async action_SaveExcel() {
            await this.fetchData()
            const { shortName } = this.hospital.selectedHospital

            const saveInfo = {
                hospitalName: shortName,
                selectedDate: this.selectedDate
            }

            const selectedInfo = {
                selectedGroups: this.selectedGroups,
                selectedManagers: this.selectedManagers,
                selectedTimeInterval: this.selectedTimeInterval
            }

            const result = await scheduleExcelController.saveScheduleExcel(this.excelData, saveInfo, selectedInfo)

            if (result) {
                this.setToast({
                    isShow: true,
                    text: this.$t('common.label_save_success')
                })
            }

            this.action_ClosePopup()
        }
    }
}
</script>
